<template>
  <div class="panel-body">
    <div v-if="loading" class="loading fullheight" id="loader">
      <div class="lds-dual-ring"></div>
    </div>
    <vue-form-generator :schema="schema" :model="model" :options="formOptions"></vue-form-generator>
    <div style="background: #f0f0f0" v-if="!this.model.products.length"></div>
    <div v-else>
       <table-component table-class="fulltable" v-if="this.model.products.length > 0" :show-filter="false" :show-caption="false" :filter-no-results="''" :data="this.model.products" ref="upload">
        <table-column show="vueTableComponentInternalRowId" label="id" hidden></table-column>
				<table-column show="confezione" label="Confezione"></table-column>
				<table-column show="pezzatura" label="Pezzatura"></table-column>
				<table-column show="quantita" label="Quantità"></table-column>
        <table-column label="Rimuovi">
          <template slot-scope="row">       
           <span class="btn-remove">
          <b-button @click="delProduct(row.vueTableComponentInternalRowId)">X</b-button>
        </span>
          </template>
        </table-column>
       </table-component>
       </div>
      <vue-form-generator :schema="schema_send" :model="model" :options="formOptions"></vue-form-generator>
      <p>{{this.msg_conferma}}</p>
      <p v-if="msg_packaging_record">{{this.msg_packaging_record}}</p>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
export default {
  name: 'confezionamento',
  components: {
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_ROOT_API,
      config: {headers: { Authorization: 'bearer ' + localStorage.getItem('access_token') }},
      counter: 0,
      codicelotto: '',
      msg_conferma: '',
      msg_packaging_record: '',
      loading: false,
      sent: false,
      model: {
        batch_code:[],
        data_confezionamento:'',
        object: {
          confezione: '',
          pezzatura: '',
          quantita: ''
        },
        products: []
      },
      schema: {
        fields: [
          {
            type: 'select',
            inputType: 'number',
            label: 'Codice del lotto',
            model: 'batch_code',
            values: [],
            optionsLimit:5,
            selectOptions: {
              hideNoneSelectedText: true
            }
          },
          {
            type: 'input',
            inputType: 'date',
            label: 'Data confezionamento',
            model: 'data_confezionamento',
            placeholder: 'Inserire data uscita',
            required: true
          },
          {
            type: 'object',
            label: 'Referenze',
            model: 'object',
            schema : {
             fields: [
              {
            type: 'select',
            label: 'Confezione',
            model: 'confezione',
            values: ['Termo', 'Ciuffo', 'Vaschetta', 'Bicchiere', 'Secchiello', 'Tris'],
            selectOptions: {
              hideNoneSelectedText: true
            },
            required: true
          },
          {
            type: 'select',
            label: 'Pezzatura',
            model: 'pezzatura',
            values: ['10x25g', '10x50g', '125g', '150g', '200g', '250g', '500g', '2x100g','2x125g','50x10g','5x50g', '8x31,5g', '3x125g', '4x125g', '5x100g', '20x25g', '5x25g'],
            selectOptions: {
              hideNoneSelectedText: true
            },
            required: true
          },
          {
            type: 'input',
            inputType: 'number',
            label: 'Quantità',
            model: 'quantita',
            placeholder: 'Inserire quantità prodotto',
            required: true
          },
          {
            type: 'submit',
            buttonText: 'Aggiungi',
            validateBeforeSubmit: true,
            onSubmit: this.addProduct
          }
              ]
            }
          }
        ]
      },
      schema_send: {
        fields: [
          {
            type: 'submit',
            buttonText: 'Invia',
            validateBeforeSubmit: true,
            onSubmit: this.saveForm,
            disabled: false
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: false,
        validateAsync: false
      }
    }
  },
  mounted () {
    this.getProducts()
  },
  methods: {
    counterPlus: function () {
    },
    addProduct: function () {
      // eslint-disable-next-line
      //console.log("setting data ", this.model.object)

      this.model.products.push(this.model.object)
      // eslint-disable-next-line
      //console.log(this.model.products)
      this.model.object = {}
    },
    delProduct: function (id) {
      // eslint-disable-next-line
      // console.log("id "+ id)
      for (var i in this.model.products) {
        var row = this.model.products[i]

      if (row.vueTableComponentInternalRowId == id) {

        var index = this.model.products.indexOf(i)
        // eslint-disable-next-line
        //console.log("counter " + this.counter + "id " + id)
        // eslint-disable-next-line
        //console.log("counter " + this.counter +"index" + index)

        this.model.products.splice(index,1)
          
        }
      }
    },
    saveForm: function (model) {
      if (!this.model.batch_code || !this.model.products.length || !this.model.data_confezionamento) {
        this.msg_packaging_record = 'Compila tutti i campi e riprova'
      }
      else {
      this.msg_packaging_record = ''
      this.loading = true
      this.model.object = {}

      this.$store.dispatch('update_confezionamento', model)

      // eslint-disable-next-line
      // console.log("data prima Formattazione -> " + this.model.data_confezionamento)
     
     var data_batch_code = new Date(this.model.data_confezionamento)

      var month = ("0" + (data_batch_code.getMonth() + 1)).slice(-2)

      var day = ("0" + (data_batch_code.getDate())).slice(-2)

      var year = (data_batch_code.getFullYear())
      
      // eslint-disable-next-line
      // console.log("data_batch_code -> " + data_batch_code + "-month -> " + month + " day -> " + day + " year -> " + year)



      let data_batch_code_formatted = year + "-" + month + "-" + day + " 17:00:00"

      // eslint-disable-next-line
      // console.log(data_batch_code_formatted)

    axios.put(this.apiUrl + 'products/'+ this.model.batch_code, 
    {
      "packaging_date": data_batch_code_formatted,
    }, this.config).then(() => {
          //console.log(response.data)    

    for (var s in this.schema.fields[0].values) {
      var c = this.schema.fields[0].values[s]
      if (c.id === this.model.batch_code)
      {
        this.codicelotto = c.code
      } 
    }

    for (var p=0; p < this.model.products.length; p++) {
      var pack = this.model.products[p]
      axios.post(this.apiUrl + 'packagings/', 
      {
        "code": this.model.batch_code,
        "name": pack.confezione,
        "sizing": pack.pezzatura,
        "quantity": pack.quantita
      }, this.config
      ).then(() => {
        // eslint-disable-next-line
        return
        // console.log(response.data)
      })
    }
  this.msg_conferma = 'Referenze memorizzate correttamente'
  this.model.products = []
  this.sent = true
  this.schema_send.fields[0].disabled = true
    }).catch((error) => { 
      // eslint-disable-next-line
      console.log(error)
      this.msg_conferma = 'Si è verificato un errore, riprova'
      }).finally(() => {
      this.loading = false
  })
      }
    },
    getProducts: function () {
    this.loading = true
    axios.get(this.apiUrl + 'products?_sort=created_at:DESC', this.config)
      .then(response => {
      let batch_values = []
      for (let r of response.data) {
        batch_values.push(
          {"name": r.code,
          "id" : r.id
          }
        )
      }
      // eslint-disable-next-line
      //console.log("Getting data:", batch_values)
      this.$store.commit('BATCHLIST_FETCH', batch_values)
      this.schema.fields[0].values = batch_values
      this.loading = false
      })
    }
  }
  }
</script>

<style>
.btn-remove{
  display:block;
  margin-top: 2%;
  margin-bottom: 2%;
}
.info-prodotto{
  display: block;
  border:2px solid #520008;
  width: 50%;
  margin: auto;
  border-radius:20px;
  padding: 1%;
  margin-bottom: 1%;


}
.class-id, .class-pezzatura, .class-confezione, .class-quantita{
  font-size: 2rem;
}
.fulltable {
  width: 100%;
}


</style>
